
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { useLanguage } from "@/contexts/language";
import { t } from "@/utils/translations";
import { AlertTriangle } from "lucide-react";

interface NoGrowthDataMessageProps {
  heightData: any[];
  weightData: any[];
  milkData?: any[];
}

export function NoGrowthDataMessage({ heightData, weightData, milkData = [] }: NoGrowthDataMessageProps) {
  const { language } = useLanguage();
  
  // Check if data exists for any chart
  const hasAnyData = heightData.length > 0 || weightData.length > 0 || milkData.length > 0;
  
  if (hasAnyData) {
    return null;
  }
  
  return (
    <Alert className="mt-8 bg-amber-50 border-amber-200">
      <AlertTriangle className="h-5 w-5 text-amber-500" />
      <AlertTitle className="text-amber-700">
        {t('statistics.noDataAvailable', language)}
      </AlertTitle>
      <AlertDescription className="text-amber-600">
        {t('statistics.addMeasurementsInDiary', language) || 
          "Add height, weight, or milk intake information when creating diary entries to see them visualized here."}
      </AlertDescription>
    </Alert>
  );
}
